export default "__VITE_ASSET__Cf1qF5eL__"